import { Feature } from '@tencent/workbench';
import BaseMobileContextMenuFeature from '@framework/workbench/common/feature/base-mobile-context-feature';
import { config } from './config';

@Feature()
export class RotateFeature extends BaseMobileContextMenuFeature {
    id = config.name;

    /**
     * 进入旋转态
     */
    public setRotate() {
        this.getAppServices().editableServiceLayer?.rotateElementHandler.setIsMobileRotatingMode(true);
    }
}
